module.exports = __webpack_public_path__ + "static/media/highRiskBg.67f8c5e8.png";